var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "./storyRow.css";
import str1 from "../../assets/images/str1.png";
import str2 from "../../assets/images/str2.png";
import str3 from "../../assets/images/str3.png";
import str4 from "../../assets/images/str4.png";
import str6 from "../../assets/images/str6.png";
import str7 from "../../assets/images/str7.png";
import canliIzleIcon from "../../assets/images/canli-izle-icon.png";
import banaOzelIcon from "../../assets/images/bana-ozel-icon.png";
import populerOyunlarIcon from "../../assets/images/populer-oyunlar-icon.png";
import oyunlarIcon from "../../assets/images/oyunlar-icon.png";
import yeniOyunlarIcon from "../../assets/images/yeni-oyunlar-icon.png";
import kampanyalarIcon from "../../assets/images/kampanyalar-icon.png";
import cekilislerIcon from "../../assets/images/cekilisler-icon.png";
import yeniCekilislerIcon from "../../assets/images/yeni-cekilisler-icon.png";
import sssIcon from "../../assets/images/sss-icon.png";
import Modal from "react-modal";
import { useNavigate } from "react-router-dom";
import paths from "../../paths";
import { raffleDraws, raffleSubject } from "../../store/games.store";
import { Ticket } from "../../shared/ticket/ticket";
import { cartToggleSubject } from "../../store/cart.store";
export function StoryRow() {
    var _this = this;
    var _a = useState(null), activeStoryId = _a[0], setActiveStoryId = _a[1];
    var _b = useState(0), progress = _b[0], setProgress = _b[1];
    var _c = useState([]), stories = _c[0], setStories = _c[1];
    var _d = useState(true), loading = _d[0], setLoading = _d[1];
    var _e = useState([]), randomRaffles = _e[0], setRandomRaffles = _e[1];
    var _f = useState(0), refreshCount = _f[0], setRefreshCount = _f[1];
    var _g = useState(window.innerWidth < 768), isMobile = _g[0], setIsMobile = _g[1];
    var progressIntervalRef = useRef(null);
    var navigate = useNavigate();
    // Placeholder stories - API başarısız olursa kullanılacak
    var placeholderStories = [
        {
            id: 1,
            title: "Çekilişler",
            img: str2,
            modalImage: str2,
            isLink: true,
            linkUrl: paths.raffleTickets.url,
            order: 1
        },
        {
            id: 2,
            title: "Oyunlar",
            img: str1,
            modalImage: str1,
            isLink: true,
            linkUrl: paths.games.url,
            order: 2
        },
        {
            id: 3,
            title: "Yeni Çekilişler",
            img: str1,
            modalImage: str1,
            isLink: true,
            linkUrl: paths.raffleTickets.url,
            order: 3
        },
        {
            id: 4,
            title: "Yeni Oyunlar",
            img: str2,
            modalImage: str2,
            isLink: true,
            linkUrl: paths.newGames.url,
            order: 4
        },
        {
            id: 5,
            title: "Kampanyalar",
            img: str4,
            modalImage: str4,
            isLink: true,
            linkUrl: paths.campaign.url,
            order: 5
        },
        {
            id: 6,
            title: "Canlı İzle",
            img: canliIzleIcon,
            modalImage: canliIzleIcon,
            isLink: true,
            linkUrl: paths.liveStream.url,
            order: 6
        },
        {
            id: 7,
            title: "S.S.S.",
            img: sssIcon,
            modalImage: sssIcon,
            isLink: true,
            linkUrl: paths.support.url,
            order: 7
        },
        {
            id: 8,
            title: "Duyurular",
            img: str3,
            modalImage: str3,
            isLink: true,
            linkUrl: paths.notifications.url,
            order: 8
        },
        {
            id: 9,
            title: "Sana Özel",
            img: banaOzelIcon,
            modalImage: banaOzelIcon,
            isLink: false,
            order: 9
        },
        {
            id: 10,
            title: "Popüler Oyunlar",
            img: str7,
            modalImage: str7,
            isLink: true,
            linkUrl: paths.games.url,
            order: 10
        },
        {
            id: 11,
            title: "Şans Kutusu",
            img: str6,
            modalImage: str6,
            isLink: false,
            order: 11
        },
        {
            id: 12,
            title: "Bakiye Yükle",
            img: str4,
            modalImage: str4,
            isLink: true,
            linkUrl: paths.deposit.url,
            order: 12
        }
    ];
    // API'den stories verilerini çek
    var fetchStories = function () { return __awaiter(_this, void 0, void 0, function () {
        var mockApiResponse, sortedStories;
        return __generator(this, function (_a) {
            try {
                setLoading(true);
                mockApiResponse = [
                    {
                        id: 1,
                        title: "Çekilişler",
                        img: cekilislerIcon,
                        modalImage: cekilislerIcon,
                        isLink: true,
                        linkUrl: paths.raffleTickets.url,
                        order: 1
                    },
                    {
                        id: 2,
                        title: "Oyunlar",
                        img: oyunlarIcon,
                        modalImage: oyunlarIcon,
                        isLink: true,
                        linkUrl: paths.games.url,
                        order: 2
                    },
                    {
                        id: 3,
                        title: "Yeni Çekilişler",
                        img: yeniCekilislerIcon,
                        modalImage: yeniCekilislerIcon,
                        isLink: true,
                        linkUrl: paths.raffleTickets.url,
                        order: 3
                    },
                    {
                        id: 4,
                        title: "Yeni Oyunlar",
                        img: yeniOyunlarIcon,
                        modalImage: yeniOyunlarIcon,
                        isLink: true,
                        linkUrl: paths.newGames.url,
                        order: 4
                    },
                    {
                        id: 5,
                        title: "Kampanyalar",
                        img: kampanyalarIcon,
                        modalImage: kampanyalarIcon,
                        isLink: true,
                        linkUrl: paths.campaign.url,
                        order: 5
                    },
                    {
                        id: 6,
                        title: "Canlı İzle",
                        img: canliIzleIcon,
                        modalImage: canliIzleIcon,
                        isLink: true,
                        linkUrl: paths.liveStream.url,
                        order: 6
                    },
                    {
                        id: 7,
                        title: "S.S.S.",
                        img: sssIcon,
                        modalImage: sssIcon,
                        isLink: true,
                        linkUrl: paths.support.url,
                        order: 7
                    },
                    {
                        id: 8,
                        title: "Duyurular",
                        img: str3,
                        modalImage: str3,
                        isLink: true,
                        linkUrl: paths.notifications.url,
                        order: 8
                    },
                    {
                        id: 9,
                        title: "Sana Özel",
                        img: banaOzelIcon,
                        modalImage: banaOzelIcon,
                        isLink: false,
                        order: 9
                    },
                    {
                        id: 10,
                        title: "Popüler Oyunlar",
                        img: populerOyunlarIcon,
                        modalImage: populerOyunlarIcon,
                        isLink: true,
                        linkUrl: paths.games.url,
                        order: 10
                    },
                    {
                        id: 11,
                        title: "Şans Kutusu",
                        img: str6,
                        modalImage: str6,
                        isLink: false,
                        order: 11
                    },
                    {
                        id: 12,
                        title: "Bakiye Yükle",
                        img: str4,
                        modalImage: str4,
                        isLink: true,
                        linkUrl: paths.deposit.url,
                        order: 12
                    },
                ];
                sortedStories = mockApiResponse.sort(function (a, b) { return a.order - b.order; });
                setStories(sortedStories);
            }
            catch (error) {
                console.error('Stories API error:', error);
                // API başarısız olursa placeholder stories kullan
                setStories(placeholderStories);
            }
            finally {
                setLoading(false);
            }
            return [2 /*return*/];
        });
    }); };
    // Rastgele çekilişleri seç
    var getRandomRaffles = function () {
        // Satışta olan çekilişleri filtrele
        var availableRaffles = raffleDraws.filter(function (raffle) {
            return (raffle.status === true || raffle.status === 1) &&
                raffle.remaining_tickets > 0;
        });
        // Rastgele 3 çekiliş seç
        if (availableRaffles.length > 0) {
            var shuffled = __spreadArray([], availableRaffles, true).sort(function () { return 0.5 - Math.random(); });
            var selected = shuffled.slice(0, Math.min(3, shuffled.length));
            setRandomRaffles(selected);
        }
        else {
            setRandomRaffles([]);
        }
    };
    // Window resize listener for mobile detection
    useEffect(function () {
        var handleResize = function () {
            setIsMobile(window.innerWidth < 768);
        };
        window.addEventListener('resize', handleResize);
        return function () { return window.removeEventListener('resize', handleResize); };
    }, []);
    // Component mount olduğunda API'yi çağır ve çekilişleri dinle
    useEffect(function () {
        fetchStories();
        // Çekiliş verileri yüklendiğinde rastgele seç
        var raffleSubscriber = raffleSubject.subscribe(function () {
            getRandomRaffles();
        });
        // İlk yüklemede de çekilişleri al
        if (raffleDraws.length > 0) {
            getRandomRaffles();
        }
        return function () {
            raffleSubscriber.unsubscribe();
        };
    }, []);
    // Refresh count değiştiğinde yeni çekilişler seç
    useEffect(function () {
        if (refreshCount > 0) {
            getRandomRaffles();
        }
    }, [refreshCount]);
    function handleStoryClick(id) {
        var story = stories.find(function (s) { return s.id === id; });
        // Eğer story bir link ise, sayfaya yönlendir
        if (story && story.isLink) {
            navigate(story.linkUrl);
            return;
        }
        // Normal story ise modal aç
        openModal(id);
    }
    function openModal(id) {
        // Clear any existing timer first
        if (progressIntervalRef.current) {
            clearInterval(progressIntervalRef.current);
            progressIntervalRef.current = null;
        }
        setActiveStoryId(id);
        setProgress(0);
        // Şans Kutusu için progress bar'ı durdur ve çekilişleri yenile
        var story = stories.find(function (s) { return s.id === id; });
        if (story && story.title === "Şans Kutusu") {
            // Şans Kutusu için progress bar çalışmasın
            getRandomRaffles();
            return;
        }
        // Start progress animation
        progressIntervalRef.current = setInterval(function () {
            setProgress(function (prev) {
                if (prev >= 100) {
                    closeModal();
                    return 0;
                }
                return prev + 1;
            });
        }, 160); // 15 seconds total duration
    }
    function closeModal() {
        setActiveStoryId(null);
        setProgress(0);
        if (progressIntervalRef.current) {
            clearInterval(progressIntervalRef.current);
            progressIntervalRef.current = null;
        }
    }
    function nextStory() {
        if (activeStoryId) {
            var currentIndex = stories.findIndex(function (story) { return story.id === activeStoryId; });
            var nextIndex = (currentIndex + 1) % stories.length;
            openModal(stories[nextIndex].id);
        }
    }
    function previousStory() {
        if (activeStoryId) {
            var currentIndex = stories.findIndex(function (story) { return story.id === activeStoryId; });
            var previousIndex = currentIndex === 0 ? stories.length - 1 : currentIndex - 1;
            openModal(stories[previousIndex].id);
        }
    }
    // Cleanup interval on unmount
    useEffect(function () {
        return function () {
            if (progressIntervalRef.current) {
                clearInterval(progressIntervalRef.current);
            }
        };
    }, []);
    var activeStory = stories.find(function (story) { return story.id === activeStoryId; });
    var isModalOpen = activeStoryId !== null;
    if (loading) {
        return (_jsx("div", __assign({ className: "row story-row px-4" }, { children: _jsx("div", __assign({ className: "col-12 text-center" }, { children: _jsx("div", __assign({ className: "spinner-border text-light", role: "status" }, { children: _jsx("span", __assign({ className: "visually-hidden" }, { children: "Y\u00FCkleniyor..." })) })) })) })));
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", __assign({ className: "row story-row px-4" }, { children: _jsx(Swiper, __assign({ spaceBetween: 10, breakpoints: {
                        0: {
                            slidesPerView: 5,
                            spaceBetween: 10,
                        },
                        768: {
                            slidesPerView: 12,
                            spaceBetween: 10,
                        },
                    }, modules: [Navigation], navigation: true, className: "story-swiper" }, { children: stories.map(function (story) { return (_jsx(SwiperSlide, __assign({ className: "story-slide" }, { children: _jsxs("div", __assign({ className: "story-slide-content" }, { children: [_jsx("a", __assign({ onClick: function () { return handleStoryClick(story.id); }, className: "story-link" }, { children: _jsx("div", __assign({ className: "imgCircleContainer" }, { children: _jsx("img", { src: story.img, className: "img-fluid", alt: story.title }) })) })), _jsx("h5", __assign({ className: "storyText" }, { children: story.title }))] })) }), story.id)); }) })) })), _jsx(Modal, __assign({ isOpen: isModalOpen, className: "story-modal", onRequestClose: closeModal, contentLabel: "Story Modal", style: {
                    overlay: {
                        backgroundColor: 'rgba(0, 0, 0, 0.95)',
                        backdropFilter: 'blur(5px)',
                        zIndex: 9999,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    },
                    content: {
                        position: 'relative',
                        top: 'auto',
                        left: 'auto',
                        right: 'auto',
                        bottom: 'auto',
                        border: 'none',
                        background: 'transparent',
                        padding: 0,
                        margin: 0,
                        width: '100vw',
                        height: 'calc(100vh - 4rem)',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        overflow: 'hidden'
                    }
                } }, { children: activeStory && (_jsx("div", __assign({ className: "story-modal-content" }, { children: activeStory.title === "Şans Kutusu" ? (_jsxs("div", __assign({ className: "luck-box-content" }, { children: [_jsxs("div", __assign({ className: "luck-box-header" }, { children: [_jsx("h2", __assign({ className: "luck-box-title" }, { children: "\u015Eans Kutusu" })), _jsx("p", __assign({ className: "luck-box-description" }, { children: "Sistemin senin i\u00E7in se\u00E7ti\u011Fi 3 \u00E7ekili\u015F biletini g\u00F6r\u00FCnt\u00FCle ve sepete ekle" }))] })), _jsx("div", __assign({ className: "luck-box-raffles" }, { children: randomRaffles.length > 0 ? (_jsx("div", __assign({ className: "row px-2" }, { children: randomRaffles.map(function (raffle, index) { return (_jsx("div", __assign({ className: "col-12 col-md-4 p-2" }, { children: _jsx(Ticket, { item: raffle }) }), "luck-box-raffle-".concat(raffle.id, "-").concat(index))); }) }))) : (_jsxs("div", __assign({ className: "luck-box-loading" }, { children: [_jsx("div", __assign({ className: "spinner-border text-light", role: "status" }, { children: _jsx("span", __assign({ className: "visually-hidden" }, { children: "Y\u00FCkleniyor..." })) })), _jsx("p", __assign({ className: "mt-3" }, { children: "\u00C7ekili\u015Fler y\u00FCkleniyor..." }))] }))) })), _jsxs("div", __assign({ className: "luck-box-actions" }, { children: [_jsx("button", __assign({ className: "btn btn-outline-light btn-refresh", onClick: function () {
                                            if (refreshCount < 3) {
                                                setRefreshCount(function (prev) { return prev + 1; });
                                                getRandomRaffles();
                                            }
                                        }, disabled: refreshCount >= 3 }, { children: refreshCount >= 3 ? 'Yenileme Hakkı Bitti' : "Yenile (".concat(3 - refreshCount, " kald\u0131)") })), _jsx("button", __assign({ className: "btn btn-success btn-go-to-cart", onClick: function () {
                                            closeModal();
                                            cartToggleSubject.next({ action: "visibleToggleCart", show: true });
                                        } }, { children: "Sepete Git" }))] })), _jsx("button", __assign({ className: "story-close-btn", onClick: closeModal }, { children: "\u00D7" }))] }))) : (_jsxs(_Fragment, { children: [_jsx("div", __assign({ className: "story-progress-container" }, { children: _jsx("div", __assign({ className: "story-progress-bar" }, { children: _jsx("div", { className: "story-progress-fill", style: { width: "".concat(progress, "%") } }) })) })), _jsx("div", __assign({ className: "story-image-container" }, { children: _jsx("img", { className: "story-modal-image img-fluid", src: activeStory.modalImage, alt: activeStory.title }) })), _jsx("button", __assign({ className: "story-nav-btn story-nav-left", onClick: previousStory, "aria-label": "Previous story" }, { children: "\u2039" })), _jsx("button", __assign({ className: "story-nav-btn story-nav-right", onClick: nextStory, "aria-label": "Next story" }, { children: "\u203A" })), _jsx("button", __assign({ className: "story-close-btn", onClick: closeModal }, { children: "\u00D7" }))] })) }))) }))] }));
}
